import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
export var ShowMoreBlock = styled.div.withConfig({
  displayName: "ShowMoreBlock",
  componentId: "sc-1wwo50w-0"
})(["position:relative;top:", ";", ";color:", ";text-align:center;"], function (_ref) {
  var small = _ref.small;
  return small ? '-6px' : 0;
}, function (_ref2) {
  var small = _ref2.small;
  return small ? getFont(-1) : getFont(0);
}, function (_ref3) {
  var theme = _ref3.theme,
    light = _ref3.light;
  return light ? theme.colors.fontL : theme.mainColor;
});